<template>
  <b-row>
    <b-col>
      <cabecalho-repeticao
        titulo="Adicione as informações do serviço assinante"
        :mostrar-adicionar="false"
        @apply="adicionarItem"
        @remove="removerItem"
      />
      <div class="d-flex flex-column w-100">
        <div class="d-flex flex-row w-100 mb-1">
          <div class="flex-fill mr-2">
            <b-form-group label="Nome">
              <validation-provider
                #default="{ errors }"
                :name="`Nome${itemAcesso}`"
              >
                <b-input
                  v-model="valueInner.nome"
                  @input="emitChange"
                />
                <small class="text-danger">{{ errors[0] ? 'O campo Nome é obrigatório' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="flex-fill ml-2">
            <b-form-group label="Evento">
              <validation-provider
                #default="{ errors }"
                :name="`Tipo${itemAcesso}`"
              >
                <b-select
                  v-model="valueInner.tipoEvento"
                  :options="options"
                  @input="emitChange"
                />
                <small class="text-danger">{{ errors[0] ? 'O campo tipo é obrigatório' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>
        <div class="d-flex flex-row w-100">
          <div class="flex-fill mr-2">
            <b-form-group label="Url de destino">
              <validation-provider
                #default="{ errors }"
                :rules="!valueInner.tipoEvento ? '' : 'required'"
                :name="`Chave${itemAcesso}`"
              >
                <b-input
                  v-model="valueInner.urlDestino"
                  :disabled="valueInner.tipoEvento === null"
                  @input="emitChange"
                />
                <small class="text-danger">{{ errors[0] ? 'O campo Chave é obrigatório' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="flex-fill ml-2">
            <b-form-group label="Chave Secreta">
              <validation-provider
                #default="{ errors }"
                :rules="!valueInner.secretKey ? '' : 'required'"
                :name="`Segredo${itemAcesso}`"
              >
                <b-input
                  v-model="valueInner.secretKey"
                  :disabled="valueInner.tipoEvento === null"
                  @input="emitChange"
                />
                <small class="text-danger">{{ errors[0] ? 'O campo Segredo é obrigatório' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'

export default {
  name: 'ConfiguracaoApiRow',
  components: {
    ValidationProvider,
    CabecalhoRepeticao: () => import('@/shared/components/cabecalho-repeticao/CabecalhoRepeticao.vue'),
  },
  props: {
    tiposEvento: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      required: true,
    },
    itemAcesso: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      required,
      valueInner: {
        nome: null,
        tipoEvento: null,
        urlDestino: null,
        secretKey: null,
        ativo: true,
      },
    }
  },
  computed: {
    options() {
      return [
        { value: null, text: 'Selecione um evento' },
        ...this.tiposEvento.map((text, idx) => ({
          value: idx,
          text,
        })),
      ]
    },
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.valueInner = val
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    removerItem() {
      this.$emit('remove', this.itemAcesso)
    },
    adicionarItem() {
      this.$emit('novo', this.valueInner)
    },
    emitChange() {
      this.$emit('input', this.valueInner)
    },
  },
}
</script>
